import { evaluations } from './role'

export const queries = {
  evaluations,
}
export default queries
